import { useStaticQuery, graphql } from 'gatsby';

export const useHomepage = () => {
	const { data, faqs, helped_clients } = useStaticQuery(
		graphql`
			query HomePage {
				data: allDatoCmsHomepage {
					nodes {
						bannerHeading
						bannerLearnMoreLink
						bannerPartnersLink
						bannerSubheading
						bannerDescription
						bannerImage {
							url
						}
						contactSectionHeader
						contactSectionDescription
						contactSectionSignupCta
						guideSectionTitle
						hero {
							fluid {
								...GatsbyDatoCmsFluid_noBase64
							}
						}
						heroCta
						heroBackground {
							gatsbyImageData(placeholder: BLURRED)
						}
						heroHeader
						heroSubheader
						heroImage {
							gatsbyImageData(placeholder: BLURRED)
						}
						infographicVideoSectionHeader
						infographicVideoSectionBody
						screenshotFeatureExample1
						screenshotFeatureLine1
						screenshotFeatureExample2
						screenshotFeatureLine2
						screenshotFeatureExample3
						screenshotFeatureLine3
						screenshotHeader
						screenshotText
						whyEarlypayCta
						whyEarlypayDescription
						whyEarlypayHeader
						whyEarlypayGridPhotos {
							gatsbyImageData(placeholder: DOMINANT_COLOR)
						}
						eligibilityTitle
						eligibilityDescription
						forBusinessHeader
						forBusinessDescription
						forBusinessCta
						seoKeywords
						financeOptionsHeader
						showFaqs
						metaTags {
							title
							description
							twitterCard
							image {
								url
							}
						}
					}
				}
				faqs: allDatoCmsHomepageFaq {
					nodes {
						answer
						question
						id
					}
				}
				helped_clients: allDatoCmsHelpedClient(sort: { position: ASC }) {
					nodes {
						icon {
							url
						}
						industry
						tradingSince
						solution
						facilityLimit
						loanAmount
						purpose
					}
				}
			}
		`
	);

	return {
		data: data.nodes[0],
		faqs: faqs.nodes,
		helped_clients: helped_clients.nodes,
	};
};
